export default {
	data() {
		return {
			filterCategories: [
				{
					text: 'All Goals',
					value: -1
				},
				{
					text: 'Business Goals',
					value: 2
				},
				{
					text: 'Professional Development Goals',
					value: 0
				},
				{
					text: 'Personal Goals',
					value: 1
				}
			]
		};
	},
	methods: {
		getCategoryChipText(type, appendGoal = false) {
			const suffix = appendGoal ? ' Goal' : '';
			switch (type) {
				case 0:
					return `Professional Development${suffix}`;
				case 1:
					return `Personal${suffix}`;
				case 2:
					return `Business${suffix}`;
			}
		},
		getCategoryChipColor(type) {
			switch (type) {
				case 0:
					return 'primary';
				case 1:
					return 'purple';
				case 2:
					return 'orange';
			}
		}
	}
};
